[
    {
        "SourceId": 48,
        "SourceName": "Class"
    },
    {
        "SourceId": 49,
        "SourceName": "Inventory"
    },
    {
        "SourceId": 50,
        "SourceName": "Package"
    },
    {
        "SourceId": 51,
        "SourceName": "Purchase"
    },
    {
        "SourceId": 52,
        "SourceName": "Recipe"
    },
    {
        "SourceId": 53,
        "SourceName": "Requisition"
    },
    {
        "SourceId": 54,
        "SourceName": "Sales"
    },
    {
        "SourceId": 55,
        "SourceName": "Spoilage"
    },
    {
        "SourceId": 56,
        "SourceName": "Transfer"
    },
    {
        "SourceId": 57,
        "SourceName": "Type"
    },
    {
        "SourceId": 58,
        "SourceName": "Supp. Item #"
    }
    

]